import { render } from "./SmallGameCover.vue?vue&type=template&id=df2cb9f0&scoped=true"
import script from "./SmallGameCover.vue?vue&type=script&lang=js"
export * from "./SmallGameCover.vue?vue&type=script&lang=js"

import "./SmallGameCover.vue?vue&type=style&index=0&id=df2cb9f0&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df2cb9f0"]])

export default __exports__